var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocLinkIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5015 14.0406C20.5015 14.2889 20.3002 14.4902 20.0519 14.4902H7.94406C7.69578 14.4902 7.4945 14.2889 7.4945 14.0406V5.94816C7.4945 5.69988 7.69578 5.49858 7.94406 5.49858H20.0519C20.3002 5.49858 20.5015 5.69988 20.5015 5.94816V14.0406ZM20.0518 4H7.94406C6.86818 4 5.996 4.87216 5.996 5.94804V8.01124H3.94806C2.87218 8.01124 2 8.8834 2 9.95928V18.0518C2 19.1278 2.87222 20 3.94818 20H5.8062C5.91654 20 6.006 19.9105 6.006 19.8002V18.7012C6.006 18.5909 5.91654 18.5014 5.80618 18.5014H3.94806C3.69978 18.5014 3.4985 18.3001 3.4985 18.0518V9.95938C3.4985 9.7111 3.69978 9.50982 3.94806 9.50982H5.996V14.0407C5.996 15.1166 6.86818 15.9888 7.94406 15.9888H16.5055V18.0518C16.5055 18.3001 16.3042 18.5014 16.0559 18.5014H8.7045C8.04176 18.5014 7.5045 19.0387 7.5045 19.7014V19.8002C7.5045 19.9105 7.59394 20 7.7043 20H16.0559C17.1318 20 18.004 19.1278 18.004 18.0519V15.9888H20.0519C21.1278 15.9888 22 15.1166 22 14.0407V5.94816C22 4.87222 21.1278 4 20.0518 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLinkIconWhite);
export default __webpack_public_path__ + "static/media/DocLinkIconWhite.212d5f4cbb43792a034e58047bb9b7c6.svg";
export { ForwardRef as ReactComponent };